import { render, staticRenderFns } from "./CustomerComparisonStatistics.vue?vue&type=template&id=b475a4ae&"
import script from "./CustomerComparisonStatistics.vue?vue&type=script&lang=js&"
export * from "./CustomerComparisonStatistics.vue?vue&type=script&lang=js&"
import style0 from "./CustomerComparisonStatistics.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports